import { useAPI } from "/src/hooks/useAPI";

export async function fetchSimulationById(apiBaseUrl, authToken, simulationId) {
    const {callAPI} = useAPI();
    try {
        const response = await callAPI(`simulation?simulation_id=${simulationId}`, {
            token: authToken,
        });

        return response;
    } catch (err) {
        console.error('Failed to fetch simulations:', err.message);
        return [];
    }
}